import { Button, ButtonGroup, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, ImageList, ImageListItem, ImageListItemBar } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DescriptionIcon from '@material-ui/icons/Description';
import PhotoIcon from '@material-ui/icons/Photo';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';

const useStyles = makeStyles((theme) => ({
  root: {},
  dropZone: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  },
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5
  },
  info: {
    marginTop: theme.spacing(1)
  },
  list: {
    maxHeight: 320
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  icon: {
    color: 'white',
  },
  image: {
    position: 'relative',
    height: 130,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  imageFull: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function FilesPreview({ className, files, readonly, setUploadingFile, setLoading }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari] = React.useState("");
 
  const handleDetayAc = (event,dosya) => {
    setLoading(true);
    var FileData = `data:${dosya.MIMEType};base64,${dosya.FileData}`
    if (dosya?.MIMEType?.includes('image')) {
      var image = new Image();
      image.src = FileData;
      var w = window.open("");
      w.document.write(image.outerHTML);
      w.document.title = dosya.Title;
      w.document.close();
    } else {
      var blobData = base64ToBlob(dosya.FileData, "application/pdf");
      openBlobInNewTab(blobData);
    }
    setLoading(false);
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }





  const handleDelete = (event,fileId) => {
    const data = files.filter((item) => item.Title !== fileId)
    setUploadingFile(data && data.length > 0 ? data : []);
    
}

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {files.length > 0 && (
        <>
          <ImageList className={classes.gridList}>
            {files.map((tile) => (
              <ImageListItem
                key={tile.DOSYA_ID}
              >
                <IconButton
                  onClick={(event) => handleDetayAc(event, tile)} aria-label={`büyük resim ${tile.Title}`}
                >
                  {
                    (tile.MIMEType === 'image/jpeg' || tile.MIMEType === 'image/png' || tile.MIMEType === 'image/gif')
                      ?
                      <PhotoIcon fontSize='large' className={classes.imageFull} />
                      :
                      (
                        tile.MIMEType === 'application/pdf' ? <PictureAsPdfIcon fontSize='large' /> : <DescriptionIcon fontSize='large' />
                      )
                  }
                </IconButton>
                <ImageListItemBar
                  title={tile.Title}
                  subtitle={<span>{(tile.DOSYA_ID < 0 ? ' Lokal' : '')}</span>}
                  actionIcon={
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                      <IconButton onClick={(event) => handleDelete(event, tile.Title)}
                        aria-label={`Delete ${tile.Title}`}
                        className={classes.icon}
                        disabled={readonly}
                      >
                        <DeleteForeverIcon color="error" />
                      </IconButton>
                    </ButtonGroup>
                  }
                />
              </ImageListItem>
            ))}
          </ImageList>
        </>
      )}
    </div>
  );
}
FilesPreview.propTypes = {
  className: PropTypes.string
};

export default FilesPreview;
